import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { AdminAppDashboardInfoResponse } from "../../models/dtos";

export const dashboardApi = createApi({
  reducerPath: "dashboardApi",
  baseQuery: baseAuthQuery("adminAppDashboard"),
  tagTypes: ["AdminAppDashboard"],
  endpoints: (builder) => ({
    getDashboardInfo: builder.query<ApiResponse<AdminAppDashboardInfoResponse>, void>({
      query: () => {
        return {
          url: "dashboardInfo",
          method: "GET"
        };
      },
      providesTags: (result, error) => {
        return ["AdminAppDashboard"];
      },
    }),
  }),
});
